import {
  Design,
  DesignChannelType,
  WorkflowChannelTts,
  DesignModuleNodeConfig,
  LanguageCode
} from '../../../types';

export type GetPromptVoiceChannelProps = {
  promptNodeConfig: DesignModuleNodeConfig;
  serialized?: Design;
};

export function getPromptVoiceChannel({
  promptNodeConfig,
  serialized
}: GetPromptVoiceChannelProps): WorkflowChannelTts | Partial<Record<LanguageCode, string>> | undefined {
  serialized ??= window.apm.serialized;
  const { ttsOverrides: ttsFlag } = serialized.rootSettings.features;
  const { isOmniChannel = false } = serialized.omniChannel ?? {};
  const { channel = {}, text, ttsOverrides = null } = promptNodeConfig ?? {};
  const defaultText = (
    (isOmniChannel) ? channel?.[DesignChannelType.voice] : null
  ) ?? text;

  if (!ttsFlag || !ttsOverrides) {
    return defaultText;
  }

  let voiceChannel: WorkflowChannelTts = {};
  Object.entries(defaultText ?? {}).forEach(([language, text = '']) => {
    const languageCode = language as LanguageCode;
    voiceChannel[languageCode] = { default: { text } };
    if (!(languageCode in ttsOverrides)) {
      return;
    }
    voiceChannel[languageCode] = {
      ...voiceChannel[languageCode],
      ...ttsOverrides[languageCode]
    };
  });
  return voiceChannel;
}
